import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import DatePicker from "../../components/datePicker"
import dayjs from "../../plugins/dayjs"
import TextInputField from "../../components/textInput"
import Button from "../../components/button"
import API from "../../api"
import InputDate from "../../components/inputDate"
import { useLanguage } from "@languages/index"

interface PropTypes {
  campaignData?: any

  productId?: any

  onUpdate?: () => void

  auth?: any
  showModal?: (params?: any) => void
  preferences?: any
}

const CampaignExtendIndex = (props: PropTypes) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.campaigns }
  const [campaign, setCampaign] = useState(props.campaignData)

  useEffect(() => {
    console.log("campaign", campaign)
  }, [])

  const handleSubmit = () => {
    const params = {
      brandToken: props.auth.token,
      campaignId: props.campaignData.id
    }

    API.Campaign.extendCampaignSchedule(params)
      .then((response) => {
        props.showModal({ text: response.message })
      })
      .catch((error) => {
        const array = {}
        if (error.data) {
          if (error.data.title) array["title"] = error.data.title
          if (error.data.text) array["text"] = error.data.text
        }
        if (error.message) array["text"] = error.message
        props.showModal(array)
      })
      .finally(() => {
        props.onUpdate ? props.onUpdate() : null
      })
  }

  return (
    <div className="flex flex-col p-10 bg-white md:w-[460px]">
      <div className="flex flex-col gap-5">
        <div className="title">
          <span className="font-bold text-xl">{languageTexts.extend_text_1}</span>

          <div className="flex flex-col gap-2 mt-8">
            <span className="text-base">{languageTexts._extend_text_2()}</span>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <span className="font-bold text-base">{languageTexts.extend_text_3}</span>

          <div className="form-input flex flex-row items-center gap-3 w-full">
            <span>{campaign.recruitStartsAt}</span>

            <span>~</span>

            <span>{dayjs(campaign.recruitEndsAt).add(7, "day").format("YYYY-MM-DD")}</span>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <span className="font-bold text-base">{languageTexts.extend_text_4}</span>

          <div className="form-input flex flex-row items-center gap-3 w-full">
            <span>{dayjs(campaign.selectionStartsAt).add(7, "day").format("YYYY-MM-DD")}</span>

            <span>~</span>

            <span>{dayjs(campaign.selectionEndsAt).add(7, "day").format("YYYY-MM-DD")}</span>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <span className="font-bold text-base">{languageTexts.extend_text_5}</span>

          <div className="form-input flex flex-row items-center gap-3 w-full">
            <span>{dayjs(campaign.productDeployAt).add(7, "day").format("YYYY-MM-DD")}</span>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <span className="font-bold text-base">{languageTexts.extend_text_6}</span>

          <div className="form-input flex flex-row items-center gap-3 w-full">
            <span>{dayjs(campaign.postingStartsAt).add(7, "day").format("YYYY-MM-DD")}</span>

            <span>~</span>

            <span>{dayjs(campaign.postingEndsAt).add(7, "day").format("YYYY-MM-DD")}</span>
          </div>
        </div>

        <div className="flex flex-col">
          <Button
            text={languageTexts.extend_text_7}
            textColor={"WHITE"}
            buttonColor={"BLACK"}
            onClick={() => {
              handleSubmit()
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(CampaignExtendIndex)
